import type { FC, ReactNode } from 'react';

import { ErrorBoundary } from './ErrorBoundary';
import { UnknownError } from './UnknownError';

interface Props {
    children: ReactNode;
}

export const RootErrorBoundary: FC<Props> = ({ children }) => {
    return (
        <ErrorBoundary
            errorContent={
                <div className="vh-100 d-flex flex-column justify-content-between">
                    <UnknownError />
                </div>
            }
        >
            {children}
        </ErrorBoundary>
    );
};
